module.exports = new __parcel__URL__("exclamation-circle-blue.6b0501ee.svg").toString();